var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"media-chooser-layer",class:{ 'media-chooser-layer--hover': _vm.hasValue }},_vm.$listeners),[_c('NiceButton',{staticClass:"media-chooser-layer-button",attrs:{"size":"small"}},[_vm._v(" "+_vm._s(_vm.actionText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }